import { useState } from './useState';

export function useLogger() {
  const { debugMode } = useState();

  function log(...args: unknown[]) {
    if (!debugMode.value) return;
    console.log(...args);
  }

  function debug(...args: unknown[]) {
    if (!debugMode.value) return;
    console.debug(...args);
  }

  function info(...args: unknown[]) {
    if (!debugMode.value) return;
    console.info(...args);
  }

  function warn(...args: unknown[]) {
    if (!debugMode.value) return;
    console.warn(...args);
  }

  function errorlog(...args: unknown[]) {
    if (!debugMode.value) return;
    console.error(...args);
  }

  return {
    log,
    debug,
    info,
    warn,
    errorlog,
  };
}
